export default __webpack_public_path__ + "static/media/shaking-hands.1ceb0128.png";